import EventOverview from "../components/EventOverview";
import { usePortal } from "../lib/portal";

export default function OverviewPage() {
  const { data } = usePortal();
  return (
    <div className="pt-[110px]">
      <EventOverview
        event={data!.event}
        announcements={data!.announcements}
        decisionStatus={data!.decisionStatus}
      />
    </div>
  );
}
